import AppContext from 'context';
import { TFeatureData } from 'context/reducers/featureToggle.type';
import { useContext, useState } from 'react';
import { checkFlagr, getUserFeatures } from 'services/user';

export const useFeatureToggle = () => {
  const {
    state: {
      features: { data },
    },
    dispatch,
  } = useContext(AppContext);

  const [isLoadingFeatureFlag, setIsLoadingFeatureFlag] = useState(false);
  const [isFetchedFeatureFlag, setIsFetchedFeatureFlag] = useState(false);
  const [isErrorFetchingFeatureFlag, setIsErrorFetchingFeature] = useState(false);
  const [userHasFeatureFlag, setUserHasFeatureFlag] = useState(false);

  const fetchFeatures = async () => {
    dispatch({ type: 'features_load' });

    try {
      const response = await getUserFeatures();

      dispatch({ type: 'features_load_success', payload: response.data });
      localStorage.setItem('userFeatures', JSON.stringify(response.data));
    } catch (err) {
      dispatch({ type: 'features_load_error', payload: err });
    }
  };

  const userHasFeature = (feature: string): boolean => {
    const result = data?.some && data?.some((item: TFeatureData) => item.feature === feature);
    return result;
  };

  const userHasFeatures = (features: string[]): boolean =>
    features?.every((feature) => data?.some((item: TFeatureData) => item.feature === feature));

  const checkUserHasFeatureInFeatureFlag = (flagId: number) => {
    setIsLoadingFeatureFlag(true);
    setIsFetchedFeatureFlag(false);
    setIsErrorFetchingFeature(false);

    checkFlagr(flagId)
      .then((response) => {
        setUserHasFeatureFlag(response?.access);
        setIsLoadingFeatureFlag(false);
        setIsFetchedFeatureFlag(true);
        setIsErrorFetchingFeature(false);
      })
      .catch(() => {
        setUserHasFeatureFlag(false);
        setIsLoadingFeatureFlag(false);
        setIsErrorFetchingFeature(true);
      });
  };

  return {
    userHasFeature,
    userHasFeatures,
    fetchFeatures,
    checkUserHasFeatureInFeatureFlag,
    isLoadingFeatureFlag,
    userHasFeatureFlag,
    isFetchedFeatureFlag,
    isErrorFetchingFeatureFlag,
  };
};

export default useFeatureToggle;
